import React from "react";
import { Router, Routes, Route } from "react-router-dom";
import HomePage from "../Pages/HomePage";
import OutletRoute from "../Components/OutletRoute";
import ReduceWaste from "../Pages/ReduceWaste";
import SaveEnergy from "../Pages/SaveEnergy";
import AboutUs from "../Pages/AboutUs";
import ContactUs from "../Pages/ContactUs";
import CourseDes from "../Pages/DetailsPage";
import VideoGallery from "../Components/VideoGallery";
import Downloads from "../Components/Downloads";
import Impact from "../Pages/Impact";
import LineChart from "../Components/LineChart"
import ImpactEnergy from "../Pages/ImpactEnergy";
import SaveWater from "../Pages/SaveWater";
import SaynoPlastic from "../Pages/SavynoPlastic";
import AdoptHealthylife from "../Pages/AdoptHalthylife";
import AdoptFood from "../Pages/AdoptFood";
import ReduceEwaste from "../Pages/ReduceEwaste";
import Pledge from "../Pages/Pledge";
import WhatsnewDetails from "../Pages/WhatsnewDetails";
import ImageGallery from "../Pages/ImageGallery";
import RasImageGallery from "../Pages/RasImageGallery";

// import EcoCalendar from "Components/SchoolAdmin/EcoCalendar";
import LifiCalender from "Pages/LifiCalender";
import SaplingDetail from "Pages/SaplingDetail";
import VeerBalDetailsPage from "Pages/VeerBalDetailsPage";
import DemaoVideos from "Pages/DemaoVideos";
import HelpManual from "Pages/HelpManual";
import NotificationReport from "Pages/NotificationReport";
import DistrictNotificationReport from "Pages/DistrictNotificationReport";
import SwachhataPublic from "Pages/SwachhataPublic";
import SwachhataVerify from "Pages/SwachhataVerify";
import SwachhataReports from "Pages/SwachhataReports";
import EWasteReports from "../Pages/EWasteReports";
import SpecialCampaign6 from "../Pages/SpecialCampaign6";
import BricsSustainableLifestyleWeek from "../Pages/BricsSustainableLifestyleWeek";

function BaseRoutingPage() {
  return (
    <>
      {/* <Router> */}
        <Routes>
          <Route path="/" element={<OutletRoute />}>
            <Route index element={<HomePage />} />
            <Route path="addopthealthylife" element={<AdoptHealthylife />} />
            <Route path="addoptfood" element={<AdoptFood />} />
            <Route path="reduceewaste" element={<ReduceEwaste />} />
            <Route path="reduce-waste" element={<ReduceWaste />} />
            <Route path="save-energy" element={<SaveEnergy />} />
            <Route path="savewater" element={<SaveWater />} />
            <Route path="saynoplastic" element={<SaynoPlastic />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="details" element={<CourseDes />} />
            <Route path="ras-gallery" element={<RasImageGallery />} />
            <Route path="image-gallery" element={<ImageGallery />} />
            <Route path="VideoGallery" element={<VideoGallery />} />
            <Route path="Downloads" element={<Downloads />} />
            <Route path="impact" element={<Impact />} />
            <Route path="Linechart" element={<LineChart />} />
            <Route path="impactenergy" element={<ImpactEnergy />} />
            <Route path="pledge" element={<Pledge />} />
            <Route path="whatsnewdetails" element={<WhatsnewDetails />} />
            <Route path="ecocalendar" element={<LifiCalender />} />
            <Route path="plantation" element={<SaplingDetail />} />
            <Route path="VeerBalDetailsPage" element={<VeerBalDetailsPage />} />
            <Route path="demo-videos" element={<DemaoVideos />} />
            <Route path="HelpManual" element={<HelpManual />} />
            <Route path="notification-report" element={<NotificationReport />} />
            <Route path="district-report/:stateName" element={<DistrictNotificationReport />} />
            {/* Swachhata Hi Seva: SWM Drive — public student learn + quiz (no login) */}
            <Route path="swachhata-hi-seva" element={<SwachhataPublic />} />
            {/* Certificate verification (QR on every school/student certificate) */}
            <Route path="swachhata-hi-seva/verify" element={<SwachhataVerify />} />
            <Route path="swachhata-hi-seva/verify/:certId" element={<SwachhataVerify />} />
            {/* Public "Solid Waste Management events": what schools did + photographs */}
            <Route path="swachhata-hi-seva/events" element={<SwachhataReports />} />
            {/* Public "E-Waste Collection Drive events": items collected + photographs (no login) */}
            <Route path="swachhata-hi-seva/e-waste-events" element={<EWasteReports />} />
            <Route path="special-campaign-6/e-waste-events" element={<EWasteReports />} />
            {/* Special Campaign 6: E-Waste — public school upload (no login; view-only before the campaign day) */}
            <Route path="special-campaign-6" element={<SpecialCampaign6 />} />
            <Route path="brics-sustainable-lifestyle-week" element={<BricsSustainableLifestyleWeek />} />
          </Route>
        </Routes>
      {/* </Router> */}
    </>
  );
}

export default BaseRoutingPage;
